import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { AttributeChoiceTypeEnum } from "gqlTypes/globalTypes";
import isEqual from "lodash/isEqual";
import pickBy from "lodash/pickBy";
import { stringify } from "query-string";
import { ArrayParam, encodeQueryParams, StringParam } from "use-query-params";
import { generateProductUrl } from "../../core/utils";
export var generateProductUrlWithAttributes = function generateProductUrlWithAttributes(product, attributes) {
  var productUrl = generateProductUrl(product.id, product.name);
  var filteredAttributes = pickBy(attributes);

  if (Object.values(filteredAttributes).length) {
    var encodedQuery = encodeQueryParams(Object.entries(filteredAttributes).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return _objectSpread({}, acc, _defineProperty({}, key, Array.isArray(value) ? ArrayParam : StringParam));
    }, {}), filteredAttributes);
    return "".concat(productUrl, "?").concat(stringify(encodedQuery));
  }

  return productUrl;
};

var getProductVariantsAttributes = function getProductVariantsAttributes(productVariants) {
  var variantsAttributes = {};
  productVariants.forEach(function (productVariant) {
    productVariant.attributes.forEach(function (productVariantAttribute) {
      var productVariantAttributeId = productVariantAttribute.attribute.id;
      var variantsAttributeExists = productVariantAttributeId in variantsAttributes;

      if (variantsAttributeExists) {
        var variantsAttributeValueExists = variantsAttributes[productVariantAttributeId].values.includes(productVariantAttribute.values[0]);

        if (!variantsAttributeValueExists) {
          variantsAttributes[productVariantAttributeId].values.push(productVariantAttribute.values[0]);
        }
      } else {
        variantsAttributes[productVariantAttributeId] = {
          attribute: productVariantAttribute.attribute,
          values: [productVariantAttribute.values[0]]
        };
      }
    });
  });
  return variantsAttributes;
};

export var getProductAttributes = function getProductAttributes(product) {
  var productVariantsAttributes = getProductVariantsAttributes(product.variants);
  return [].concat(_toConsumableArray(product.attributes), _toConsumableArray(Object.values(productVariantsAttributes)));
};
export var getDefaultProductAttributes = function getDefaultProductAttributes(metadata) {
  return metadata.filter(function (meta) {
    return meta.key.startsWith("default:attribute:");
  }).reduce(function (acc, cur) {
    return _objectSpread({}, acc, _defineProperty({}, cur.key.replace("default:attribute:", ""), cur.value));
  }, {});
};
export var getSelectedProductAttributes = function getSelectedProductAttributes(attributesFormData, productAttributes) {
  return Object.entries(attributesFormData).map(function (_ref3) {
    var _productAttributes$fi;

    var _ref4 = _slicedToArray(_ref3, 2),
        slug = _ref4[0],
        value = _ref4[1];

    var attribute = (_productAttributes$fi = productAttributes.find(function (item) {
      return item.attribute.slug === slug;
    })) === null || _productAttributes$fi === void 0 ? void 0 : _productAttributes$fi.attribute;
    return attribute ? {
      attributeId: attribute.id,
      values: Array.isArray(value) ? value : [value]
    } : null;
  }).filter(function (x) {
    return !!x;
  });
};
export var getCustomTrackValues = function getCustomTrackValues(width, configuration) {
  var multiplier = configuration === "configuration-single" ? 1 : 2;
  return {
    defaultValue: String((Number(width) * 2 + 100) * multiplier),
    maxValue: String(Number(width) * 3 * multiplier),
    minValue: String(Number(width) * 1.5 * multiplier)
  };
};
export var getDefaultValues = function getDefaultValues(product, queryParam) {
  var defaultValues = _objectSpread({}, getDefaultProductAttributes(product.metadata), queryParam);

  if (defaultValues.width && !defaultValues["custom-track"]) {
    var _getCustomTrackValues = getCustomTrackValues(defaultValues.width, defaultValues.configuration),
        defaultCustomTrackValue = _getCustomTrackValues.defaultValue;

    defaultValues["custom-track"] = String(defaultCustomTrackValue);
  }

  return defaultValues;
};
var orderedAttributes = ["door-style", "system-style", "door-color", "color-samples", "handle-color", "width", "height", "custom-track", "configuration", "door-density", "track"];
export var attributesSorter = function attributesSorter(a, b) {
  return orderedAttributes.indexOf(a.attribute.slug) - orderedAttributes.indexOf(b.attribute.slug);
};
export var attributeChoiceTypeDictionary = {
  configuration: AttributeChoiceTypeEnum.TOGGLE,
  "custom-track": AttributeChoiceTypeEnum.MULTISELECT,
  "door-color": AttributeChoiceTypeEnum.SWATCH,
  "door-density": AttributeChoiceTypeEnum.TOGGLE,
  "door-style": AttributeChoiceTypeEnum.DROPDOWN,
  "handle-color": AttributeChoiceTypeEnum.SWATCH,
  height: AttributeChoiceTypeEnum.SLIDER,
  material: AttributeChoiceTypeEnum.DROPDOWN,
  system: AttributeChoiceTypeEnum.DROPDOWN,
  "system-style": AttributeChoiceTypeEnum.DROPDOWN,
  track: AttributeChoiceTypeEnum.TOGGLE,
  width: AttributeChoiceTypeEnum.SLIDER
}; // temp fix of attribute choice type

export var tempFixAttributes = function tempFixAttributes(attributes) {
  return attributes.map(function (item) {
    var shippedChoiceType = item.attribute.choiceType;
    var properChoiceType = attributeChoiceTypeDictionary[item.attribute.slug];
    var isChoiceTypeDiffer = shippedChoiceType !== properChoiceType;

    if (isChoiceTypeDiffer) {
      if (!properChoiceType) {
        console.warn("Unknown attribute [[".concat(item.attribute.name, "]]"));
      } else {
        console.warn("Wrong choice type of ".concat(shippedChoiceType, " set for attribute [[").concat(item.attribute.name, "]].\n        Please change it to ").concat(properChoiceType));
      }
    }

    item.attribute.choiceType = properChoiceType || shippedChoiceType;
    return item;
  });
}; // temp fix of attribute choice type

export var tempFixFilterAttributes = function tempFixFilterAttributes(attributes) {
  return attributes.map(function (attribute) {
    var shippedChoiceType = attribute.choiceType;
    var properChoiceType = attributeChoiceTypeDictionary[attribute.slug];
    var isChoiceTypeDiffer = shippedChoiceType !== properChoiceType;

    if (isChoiceTypeDiffer) {
      if (!properChoiceType) {
        console.warn("Unknown attribute [[".concat(attribute.name, "]]"));
      } else {
        console.warn("Wrong choice type of ".concat(shippedChoiceType, " set for attribute [[").concat(attribute.name, "]].\n        Please change it to ").concat(properChoiceType));
      }
    }

    attribute.choiceType = properChoiceType || shippedChoiceType;
    return attribute;
  });
};
export function compareAttributes() {
  var productAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedProductAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (productAttributes.length !== selectedProductAttributes.length) {
    return false;
  }

  var productAttributesNormalized = productAttributes.reduce(function (acc, cur) {
    var attributeId = "attribute" in cur ? cur.attribute.id : cur.attributeId;
    return _objectSpread({}, acc, _defineProperty({}, attributeId, cur.values));
  }, {});
  var selectedProductAttributesNormalized = selectedProductAttributes.reduce(function (acc, cur) {
    return _objectSpread({}, acc, _defineProperty({}, cur.attributeId, cur.values));
  }, {});
  return isEqual(productAttributesNormalized, selectedProductAttributesNormalized);
}
export function extractExistingLine(lines, variantId, productAttributes) {
  var found;
  var alteredLines = [];
  lines.forEach(function (line) {
    if (line.variant.id === variantId && compareAttributes(line.productAttributes, productAttributes)) {
      found = line;
    } else {
      alteredLines.push(line);
    }
  });
  return [found, alteredLines];
}